import styled from '@emotion/styled';
import { BaseButton } from '../base/button';
import { Variables } from '../base/variables/variables';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const FileActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

export const HiddenInput = styled.input`
    display: none;
`;

export const FileList = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: 4px;
    background-color: ${Variables.Colors.nx4};
    max-height: 240px;
    overflow-y: auto;
`;

export const FileRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px;
    border-bottom: 1px solid ${Variables.Colors.n5};

    &:last-of-type {
        border-bottom: none;
    }
`;

export const FileInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
`;

export const FileName = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n100};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FileSize = styled.span`
    font-size: 12px;
    color: ${Variables.Colors.n50};
`;

export const RemoveButton = styled(BaseButton)`
    flex-shrink: 0;
`;

export const Summary = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.n50};
`;

export const DropZone = styled.div<{ $isDragging?: boolean; $disabled?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 96px;
    padding: 16px;
    border: 1px dashed
        ${({ $isDragging }) => ($isDragging ? Variables.Colors.p100 : Variables.Colors.nx16)};
    border-radius: 4px;
    background-color: ${({ $isDragging, $disabled }) =>
        $disabled ? Variables.Colors.nx4 : $isDragging ? Variables.Colors.p50 : Variables.Colors.white};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    transition:
        border-color 0.15s ease,
        background-color 0.15s ease;
`;

export const DropZoneText = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n50};
    text-align: center;
    line-height: 1.4;
`;

export const ErrorMessage = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.warning};
`;
